import type { Locale } from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import ru from 'date-fns/locale/ru';

import { i18n } from './i18n';
import { AppLocale, normalizeLocale, SOURCE_LOCALE } from './locales';

const DATE_LOCALES: Record<AppLocale, Locale> = {
  ru,
  en: enUS,
};

/** Локаль date-fns для языка интерфейса; по умолчанию — для активного. */
export function getDateLocale(locale: string = i18n.locale): Locale {
  return DATE_LOCALES[normalizeLocale(locale) ?? SOURCE_LOCALE];
}
